"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _SearchResult = _interopRequireDefault(require("./SearchResult"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _EventDateFormatter = _interopRequireDefault(require("@insided/deprecated-preact-components/Event/EventDateFormatter"));

var _EventSettings = require("@insided/deprecated-control/Event/event-settings/EventSettings");

var _CalendarEventV = _interopRequireDefault(require("@insided/destination/icons/CalendarEventV2"));

var EventSearchResult = function EventSearchResult(_ref) {
  var _hit$topic_url;

  var hit = _ref.hit,
      timeConfig = _ref.timeConfig;

  var _getTimeSettings = (0, _EventSettings.getTimeSettings)(timeConfig, undefined),
      hour12 = _getTimeSettings.hour12,
      showTimezone = _getTimeSettings.showTimezone,
      eventTimezone = _getTimeSettings.eventTimezone;

  return (0, _preact.h)(_SearchResult.default, {
    title: hit.title,
    url: (_hit$topic_url = hit.topic_url) !== null && _hit$topic_url !== void 0 ? _hit$topic_url : hit.url,
    clickCallback: function clickCallback() {},
    content: hit.first_post || '',
    icon: (0, _preact.h)(_CalendarEventV.default, {
      width: 20,
      height: 20
    }),
    featuredImage: hit.image,
    metaItems: [{
      type: 'pill',
      text: hit.type
    }, {
      type: 'text',
      text: hit.location ? (0, _preact.h)(_phrase.default, {
        p: "events.location.in.person",
        m: "Forum"
      }) : (0, _preact.h)(_phrase.default, {
        p: "events.location.online",
        m: "Forum"
      })
    }, {
      type: 'text',
      text: _EventDateFormatter.default.formatStartAtForOverviewListCustomized(hit.starts_at, hour12, showTimezone, eventTimezone)
    }]
  });
};

var _default = EventSearchResult;
exports.default = _default;